module.exports = __webpack_public_path__ + "nc_static/media/cancel.08ab0d33.svg";